import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../navbar";
import Footer from "../home/Footer";

export default function PageNotAvailable({ pageName }) {
  const { t } = useTranslation();
  
  return (
    <div className="font-sans text-gray-800 min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 bg-white flex items-center justify-center">
        <div className="mx-auto max-w-2xl px-8 py-20 text-center">
          <div className="mb-8">
            <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-[#F8F6F4]">
              <svg
                className="h-12 w-12 text-[#B2553D]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h1 className="font-trirong text-3xl font-bold text-[#1f2330] mb-4">
              {t("common.pageNotReady")}
            </h1>
            <p className="text-[15px] leading-7 text-[#6b7280] font-trirong mb-8">
              {pageName} {t("common.pageUnderDevelopment")}
            </p>
          </div>

          <Link
            to="/"
            className="inline-flex h-11 items-center justify-center bg-[#B2553D] px-8 font-poppins text-sm font-semibold text-white shadow hover:opacity-95 transition-opacity"
          >
            {t("common.backToHome")}
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}

